import { TeamOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Popover, Space } from 'antd';
import { isEmpty } from 'lodash';

export interface ApplicantsTableCell {
  mainOwner?: string | null;
  multipleApplicants?: boolean;
  others?: string[];
  mainOwnerFiscalCode: string;
}

export interface ApplicantsTableCellProps {
  applicants?: ApplicantsTableCell;
}

/**
 * Visualizzazione dei Titolari in una cella di tabella
 */
export function ApplicantsTableCell(props: ApplicantsTableCellProps) {
  const { applicants } = props;
  const { t } = useTranslation();
  if (!applicants) return null;

  const mainOwnerInfo = isEmpty(applicants.mainOwner?.trim())
    ? applicants.mainOwnerFiscalCode
    : applicants.mainOwner;

  return (
    <Space>
      {mainOwnerInfo}
      {applicants.multipleApplicants &&
        applicants.others &&
        applicants.others?.length > 0 && (
          <Popover
            title={t('submission.altri-titolari', 'Altre parti interessate')}
            content={
              <ul>
                {applicants.others.map((name, index) => (
                  <li key={index}>
                    <em>{name}</em>
                  </li>
                ))}
              </ul>
            }
          >
            <TeamOutlined />
          </Popover>
        )}
    </Space>
  );
}
